import * as actions from './actions'

const catalogMaritalStatusesModule = {
    namespaced: true,
    actions,
}

export default catalogMaritalStatusesModule
